import { Box, Flex, HStack } from '@chakra-ui/react';
import Lottie from 'lottie-react';
import React, { useEffect, useRef } from 'react';
import fastAudioData from 'src/asset/lottie-json/fast_audio.json';
import tortoiseData from 'src/asset/lottie-json/tortoise.json';

const ListenAudio = React.memo(({ data, audioControl = {} }) => {
  const { currentlyPlaying = null, onAudioPlay = () => {} } = audioControl;
  const fastAnimRef = useRef(null);
  const slowAnimRef = useRef(null);

  // Control animations based on currentlyPlaying
  useEffect(() => {
    if (currentlyPlaying === 'fast-audio') {
      slowAnimRef.current?.stop();
      fastAnimRef.current?.play();
    } else if (currentlyPlaying === 'slow-audio') {
      fastAnimRef.current?.stop();
      slowAnimRef.current?.play();
    } else {
      fastAnimRef.current?.stop();
      slowAnimRef.current?.stop();
    }
  }, [currentlyPlaying]);

  const isAudioAvailable = data?.audio && data.audio !== 'undefined' && data.audio !== 'null';
  const isSlowAudioAvailable = data?.audioSlow && data.audioSlow !== 'undefined' && data.audioSlow !== 'null';

  return (
    <Flex justifyContent="center" mb={3} alignItems="center">
      <HStack gap="5px">
        {isAudioAvailable && (
          <Box
            width={['70px', '70px', '80px']}
            height={['70px', '70px', '80px']}
            border="0.5px solid lightGray"
            borderRadius="5px"
            cursor="pointer"
            p={2}
            onClick={() => onAudioPlay(data.audio, 'fast-audio')}
            _hover={{ bg: 'gray.50' }}
          >
            <Lottie
              animationData={fastAudioData}
              lottieRef={fastAnimRef}
              autoplay={false}
              loop={true}
              style={{ width: '100%', height: '100%' }}
            />
          </Box>
        )}
        {isSlowAudioAvailable && (
          <Box
            width={['70px', '70px', '80px']}
            height={['70px', '70px', '80px']}
            border="0.5px solid lightGray"
            borderRadius="5px"
            cursor="pointer"
            p={2}
            onClick={() => onAudioPlay(data.audioSlow, 'slow-audio')}
            _hover={{ bg: 'gray.50' }}
          >
            <Lottie
              animationData={tortoiseData}
              lottieRef={slowAnimRef}
              autoplay={false}
              loop={true}
              style={{ width: '100%', height: '100%' }}
            />
          </Box>
        )}
      </HStack>
    </Flex>
  );
});

export default ListenAudio;